import { faBook, faCalendar, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import TableAdvanced from '../../../../../components/Tables/TableAdvanced/TableAdvanced'
import { useLang } from '../../../../../language'
import { ModalAlquiler } from './ModalAlquiler'
import { ModalAlquileres } from './ModalAlquileres'
import { AlquilerServices } from './services/alquileres.service'
import { isStatusSucess } from '../../../../../helpers/helpers'
import { ModalStatusServer } from '../../../../../components/Modals/ModalStatusServer'
import ButtonOrderBy from '../../../../../components/ButtonOrderBy/ButtonOrderBy'
import { EstadosAlquilerServices } from '../../../../../services/statics.service'

export const TableAlquileres = ({ data, loading, total, perPage, handleFormChange, formValuesSearch,
    fetchAlquileresGET, handleInputChangeSearch }: any) => {

    const navigate = useNavigate();

    const Lang = useLang()

    const staticEstadosAlquiler: any = EstadosAlquilerServices.GET()

    const [excluidos, setExcluidos] = useState([])
    const [incluidos, setIncluidos] = useState([])

    const [checkAll, setCheckAll] = useState(false)

    const selectAllItems = () => {
        setCheckAll(true)
        setIncluidos([])
        setExcluidos([])
    }

    const unselectAllItems = () => {
        setCheckAll(false)
        setIncluidos([])
        setExcluidos([])
    }

    const allActions = [
        {
            variant: 'outline-primary',
            label: <span><FontAwesomeIcon icon={faCalendar} className='me-2' />{Lang('VER_CALENDARIO')}</span>,
            action: () => handleShowModal_Alquileres({
                action: 'CREATE',
            }),
        },
        {
            label: <span><FontAwesomeIcon icon={faPlus} className='me-2' />{Lang('NUEVO_ALQUILER')}</span>,
            action: () => handleShowModal_Alquiler({
                action: 'CREATE',
            }),
        },
    ]

    const allActionsPerLine = [
        {
            label: <FontAwesomeIcon icon={faBook} className='me' />,
            action: (id: any) => navigate(`./${id}`),
        }
    ]

    const handleChangeCheckAll = (e: any) => {

        if (e.target.checked) {

            selectAllItems()

        } else {

            unselectAllItems()
        }
    }

    const headersTable = [
        <small>
            <ButtonOrderBy
                label={Lang('NUMERO_DE_PEDIDO')}
                id='numeropedido'
                className='text-center'
                handleInputChange={handleInputChangeSearch}
                formValuesSearch={formValuesSearch}
            />
        </small>,
        <small>{Lang('APARATO')}</small>,
        <small>{Lang('PERSONA')}</small>,
        <small className='d-block text-center'>
            <ButtonOrderBy
                label={Lang('FECHA_DESDE')}
                id='fechadesde'
                className='text-center'
                handleInputChange={handleInputChangeSearch}
                formValuesSearch={formValuesSearch}
            />
        </small>,
        <small className='d-block text-center'>
            <ButtonOrderBy
                label={Lang('FECHA_HASTA')}
                id='fechahasta'
                className='text-center'
                handleInputChange={handleInputChangeSearch}
                formValuesSearch={formValuesSearch}
            />
        </small>,
        <small className='d-block text-center'>{Lang('ESTADO')}</small>,
        ''
    ]

    const dataLineTable = [
        {
            className: '',
            name: 'numeropedido'
        },
        {
            className: '',
            name: 'producto'
        },
        {
            className: '',
            name: 'nombrepersona'
        },
        {
            className: 'text-center tex-nowrap',
            name: 'fechadesde'
        },
        {
            className: 'text-center tex-nowrap',
            name: 'fechahasta'
        },
        {
            className: 'text-center tex-nowrap',
            name: 'estado',
            adapter: staticEstadosAlquiler
        }
    ]


    // ------------ Modal Horario Evento

    const [showModal_Alquiler, setShowModal_Alquiler] = useState<any>({
        value: false,
        payload: {}
    });

    const handleCloseModal_Alquiler = () => setShowModal_Alquiler({
        value: false,
        payload: {}
    });

    const handleShowModal_Alquiler = (payload: object) => setShowModal_Alquiler({
        value: true,
        payload
    });


    // ------------ Modal Alquileres

    const [showModal_Alquileres, setShowModal_Alquileres] = useState<any>({
        value: false,
        payload: {}
    });

    const handleCloseModal_Alquileres = () => setShowModal_Alquileres({
        value: false,
        payload: {}
    });

    const handleShowModal_Alquileres = (payload: object) => setShowModal_Alquileres({
        value: true,
        payload
    });


    const [fetchPersonaEntidadPOST, fetchPersonaEntidadPOSTData] = AlquilerServices.POST()

    useEffect(() => {

        if (isStatusSucess(fetchPersonaEntidadPOSTData.status)) {

            navigate(`./${fetchPersonaEntidadPOSTData?.data?.data?.idpedido}`)
        }
    }, [fetchPersonaEntidadPOSTData])
    
    return (
        <>
            <TableAdvanced>

                <TableAdvanced.Head
                    title={Lang('ALQUILERES')}
                    allActions={allActions}
                />

                <TableAdvanced.Body
                    headers={headersTable}
                    dataLineTable={dataLineTable}
                    data={data}
                    isLoading={loading}

                    excluidos={excluidos}
                    incluidos={incluidos}
                    setExcluidos={setExcluidos}
                    setIncluidos={setIncluidos}

                    checkAll={checkAll}
                    allActionsPerLine={allActionsPerLine}
                    checkMultiples={false}
                />

                <TableAdvanced.Footer
                    total={total}
                    handleFormChange={handleFormChange}
                    formValuesSearch={formValuesSearch}
                    perPage={perPage}
                />

            </TableAdvanced>

            <ModalAlquileres
                showModal_Alquileres={showModal_Alquileres}
                handleCloseModal_Alquileres={handleCloseModal_Alquileres}
                fetchAlquileresGET={fetchAlquileresGET}
            />

            <ModalAlquiler
                showModal_Alquiler={showModal_Alquiler}
                handleCloseModal_Alquiler={handleCloseModal_Alquiler}
                fetchAlquileresGET={fetchAlquileresGET}
                formValuesSearch={formValuesSearch}
                fetchPersonaEntidadPOST={fetchPersonaEntidadPOST}
                fetchPersonaEntidadPOSTData={fetchPersonaEntidadPOSTData}
            />

            <ModalStatusServer fetchData={fetchPersonaEntidadPOSTData} />

        </>

    )
}
